import type { State } from '../../types';

export const getBaseUrl = (state: State): string => state.app.baseUrl;
export const getBoardId = (state: State): number => state.app.boardId;
export const isFirstDataLoaded = (state: State): boolean => state.app.isFirstDataLoaded;
export const isError = (state: State): boolean => state.app.isError;
export const getFetchError = (state: State): Error | null => state.app.fetchError;
